var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-content-loading',_vm._b({attrs:{"height":480}},'vue-content-loading',_vm.$attrs,false),[_c('circle',{attrs:{"cx":"30","cy":"30","r":"30"}}),_vm._v(" "),_c('rect',{attrs:{"x":"75","y":"13","rx":"4","ry":"4","width":"100","height":"13"}}),_vm._v(" "),_c('rect',{attrs:{"x":"75","y":"37","rx":"4","ry":"4","width":"50","height":"8"}}),_vm._v(" "),_c('rect',{attrs:{"x":"0","y":"70","rx":"5","ry":"5","width":"400","height":"400"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-859b634c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/presets/Instagram.vue
// module id = 22
// module chunks = 0 1